module.exports = __webpack_public_path__ + "static/media/blog-administracion-sistemas-programacion-2000.7453b2bd.jpg";